exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Grid-module__home-grid___1CTfE{padding:56px 117px;position:absolute;width:-moz-max-content;width:max-content;display:grid;grid-auto-columns:110px;grid-auto-rows:68.16px;-moz-column-gap:40px;column-gap:40px;row-gap:18.68px;transform-origin:0 0}.Grid-module__home-grid___1CTfE .Grid-module__background___35X8m{position:absolute;max-width:none}html:has(.Grid-module__home-grid___1CTfE){background-color:#3edc89}", ""]);

// exports
exports.locals = {
	"home-grid": "Grid-module__home-grid___1CTfE",
	"background": "Grid-module__background___35X8m"
};